import apiClient from "../Util/ApiClient";

export default class BankApi {

    static filter = (query = {}) => {
        return apiClient.get('/banks', {
            params: query
        })
    };
}